import React  from 'react'; 
import { Link, useNavigate } from 'react-router-dom';
import { MdKeyboardDoubleArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import profile from '../../../assets/small-logo-512x512.png'; 
import _constantUtil from '../../../utils/Constant'; 

function UpdateQuestion() {
    const navigate = useNavigate() 

  return (
    <div className=''> 
      <div className='row justify-content-center mx-4'>
        <div className='d-flex align-items-center justify-content-between p-0'>
          <h4 className='header-title mb-0 text-muted mt-3'>
            <Link onClick={() => navigate(-1)} className='header-sub-title'>
              Global Question
            </Link>
            <span className="blr-player-view">
              <MdKeyboardDoubleArrowRight className='jumbo-red-text mb-1 mx-2 ' />
            </span>
            Update Question
          </h4>
          <button
            type='button'
            className='btn text-white mt-3 d-flex'
            onClick={() => navigate(-1)}
          >
            <MdKeyboardArrowLeft className='fs-4' />
            Back
          </button>
        </div>
        <div className='card mt-3'>
          <div className='card-body'>
          <form>

            <div className='row flex-column flex-md-row p-0 d-flex align-items-center justify-content-center my-2'>
              <div className='col-12 col-md-3 col-lg-4 d-flex flex-column align-items-center justify-content-center order-1 order-md-0 mb-3 mb-md-0'>
                <img
                  src={profile}
                  alt='Profile'
                  className='img-thumbnail img-fluid'
                  style={{
                    borderRadius: '50%',
                    cursor: 'pointer',
                    objectFit: 'contain',
                    minHeight: '170px',
                    height: '170px',
                    maxWidth: '170px',
                    width: '170px',
                  }}
                />
              </div>
            </div>

            <div className='row py-2'>

              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='category' className='form-label'>
                  Category
                </label>
                <select
                  id='category'
                  className='form-select me-2' 
                >
                  <option value=''>Select Category</option>
                  <option value='1x2'>1x2</option>
                  <option value='teamwins'>Team Wins</option>
                  <option value='goalscore'>Goal Score</option> 
                </select>
              </div> 
            
              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='priority' className='form-label'>
                  Priority
                </label>
                <input
                  type='number'
                  className='form-control'
                  id='priority'
                  name='priority'
                  placeholder='0'
                  style={{background : "#7e7e7e38"}}
                  disabled
                  autoComplete='off'
                />
              </div>

              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='result' className='form-label'>
                  Result Type
                </label>
                <select
                  id='result'
                  className='form-select me-2' 
                >
                  <option value=''>Select Result Type</option>
                  <option value='instant'>instant</option>
                  <option value='aftermatch'>after match</option>
                  <option value='manual'>manual</option> 
                </select>
              </div>

              
              

              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='typeofquestion' className='form-label'>
                  Type of Question
                </label>
                <select
                  id='typeofquestion'
                  className='form-select me-2' 
                >
                  <option value=''>Select Question</option>
                  <option value='2ndhalfgoal'>2nd half goal (odd/even)</option>
                  <option value='bothteamsscore'>both teams score (2nd half)</option>
                  <option value='totalgoal'>total goal (odd/even)</option> 
                </select>
              </div>

              <div className='mb-2 col-12 col-md-8'>
                <label htmlFor='question' className='form-label'>
                  Question
                </label>
                <input
                  type='text'
                  className='form-control'
                  id='question'
                  name='question'
                  placeholder='Enter Question' 
                  autoComplete='off'
                />
              </div>

              

              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='type' className='form-label'>
                  Question Type
                </label>
                <select
                  id='questiontype'
                  className='form-select me-2' 
                >
                  <option  value=''>Select Type</option>
                  <option  value='odd/even'>odd/even</option>
                  <option  value='yes/no'>yes/no</option>
                  <option  value='eam a/team b'>team a/team b</option> 
                </select>
              </div>

              
              
              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='optionOne' className='form-label'>
                  Option One
                </label>
                <input
                  type='text'
                  className='form-control'
                  id='optionOne'
                  name='optionOne'
                  placeholder='Odd'
                  style={{background : "#7e7e7e38"}}
                  disabled
                  autoComplete='off'
                />
              </div>

              <div className='mb-2 col-12 col-md-4'>
                <label htmlFor='optionTwo' className='form-label'>
                  Option Two
                </label>
                <input
                  type='text'
                  className='form-control'
                  id='optionTwo'
                  name='optionTwo'
                  placeholder='Even'
                  style={{background : "#7e7e7e38"}}
                  disabled
                  autoComplete='off'
                />
              </div>  

            </div>
            <button type='button' className='btn text-white mt-3' style={{ float: 'right' }}>
              Save
            </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateQuestion
